import React from "react";
import ReportsSection from "./ReportsSection1";

const HeatMap = () => {
  return (
    <div >
      <div >
        <div className="md:-mb-5">
          <ReportsSection />
        </div>

        <div className="flex justify-between items-center md:mb-1 md:-mt-0 -mt-6">
          <h2 className="md:text-[24px] text-[12px] tracking-wide text-[#03897B] font-bold md:mb-2">
            <span className="text-[#979797]">REPORTS | </span>PROJECTS
          </h2>
        </div>

        {/* ADMINISTRATIVE Section */}
        <div className="mb-6 md:mt-0 mt-3">
          <div className="flex md:flex-row items-start gap-1 md:gap-[110px]">
            <div className="w-[70px] md:w-[200px]">
              <p className="text-[#F38323] font-bold text-[6px] md:text-[20px]">ADMINISTRATIVE</p>
            </div>
            <div className="grid grid-cols-9 md:grid-cols-9 md:gap-[12px] gap-[2px] flex-1">
              {[
                'GAUTTENG', 'NORTHWEST', 'FREE STATE', 'WESTERN CAPE', 'NOTHERN CAPE',
                'EASTERN CAPE', 'KWAZULU NATAL', 'LIMPOPO', 'MPUMALA NGA'
              ].map((region, i) => (
                <div key={i} className="text-[4px] md:text-[14px] tracking-wide text-black font-extrabold md:px-1 text-center md:w-[95px]">
                  {region}
                </div>
              ))}
            </div>
          </div>

          <div className="mt-2">
  <p className="text-[#F38323] font-bold mb-2 text-[6px] md:text-[20px]">ENTERPRISE</p>
  <div className='md:h-[2.5px] h-[1px] bg-black/50'></div>

  <div className="overflow-x-auto">
    <div className="md:w-auto grid md:grid-cols-[300px_repeat(9,1fr)] grid-cols-[90px_repeat(9,1fr)] md:gap-y-3 gap-y-1 gap-x-1 md:gap-x-2 mt-2 md:mt-3 ">
      {/* Row 1 */}
      <div className="text-[6px] md:text-[14px] text-black font-normal leading-tight">
        <span className="font-bold">Large Enterprises</span> / Commercial<br />farmers
      </div>
      {['345', '345', '345', '345', '345', '345', '345', '345', '345'].map((num, idx) => (
        <div key={idx} className="h-4 md:h-7 bg-[#CFD7D7] rounded-md text-[5px] md:text-[16px] flex items-center justify-center">
          {num}
        </div>
      ))}

      {/* Row 2 */}
      <div className="text-[6px] md:text-[14px] text-black font-normal leading-tight">
        <span className="font-bold">Medium Enterprises</span> / Emerging<br />farmers
      </div>
      {['2450', '2179', '2340', '3212', '2345', '3450', '2345', '2245', '3145'].map((num, idx) => (
        <div key={idx} className="h-4 md:h-7 bg-[#CFD7D7] rounded-md text-[5px] md:text-[16px] flex items-center justify-center ">
          {num}
        </div>
      ))}

      {/* Row 3 */}
      <div className="text-[6px] md:text-[14px] text-black font-normal leading-tight">
        <span className="font-bold">Small Enterprises</span> / Small<br />holder farmers
      </div>
      {['34500', '44345', '42345', '45450', '45315', '34445', '45609', '39870', '41050'].map((num, idx) => (
        <div key={idx} className="h-4 md:h-7 bg-[#CFD7D7] rounded-md text-[5px] md:text-[16px] flex items-center justify-center mb-2 md:mb-4">
          {num}
        </div>
      ))}
    </div>
  </div>
</div>

        </div>

        {/* MARKET ASSURANCE Section */}
        <div className="mt-2">
          <p className="text-[#F38323] font-semibold mb-2 text-[6px] md:text-[20px]">ABATTOIRS</p>
          <div className='h-[2.5px] bg-black/50'></div>

          <div className="grid md:grid-cols-[300px_repeat(9,1fr)] grid-cols-[90px_repeat(9,1fr)] md:gap-y-5 gap-y-1 md:gap-x-2 gap-x-1 md:mt-3 mt-1">
            {[
              { label: 'Active abattoirs', value: '345' },
              { label: 'All Abattoirs', value: '2450' },
            ].map((item, i) => (
              <React.Fragment key={i}>
                <div className="md:text-[14px] md:w-[215px] text-[6px] text-black">
                  {item.label}
                </div>
                {[...Array(9)].map((_, j) => (
                  <div
                    key={j}
                    className="md:h-7 h-4 bg-[#CFD7D7] rounded-md text-[5px] md:text-[16px] flex items-center justify-center"
                  >
                    {item.value}
                  </div>
                ))}
              </React.Fragment>
            ))}
          </div>
        </div>

        {/* SITES Section */}
        <div className="mt-2">
          <p className="text-[#F38323] font-semibold mb-2 text-[6px] md:text-[20px]">SITES</p>
          <div className='h-[2.5px] bg-black/50'></div>

          <div className="grid md:grid-cols-[300px_repeat(9,1fr)] grid-cols-[90px_repeat(9,1fr)] md:gap-y-4 gap-y-1  md:gap-x-2 gap-x-1 md:mt-3 mt-1">
            {[
              { label: 'Active sites', value: '345' },
              { label: 'Total Sites', value: '2450' },
              { label: 'Women', value: '345' },
              { label: 'Youth', value: '345' },
              { label: 'Members', value: '2450' },
              { label: 'Cooperatives', value: '2450' },
              { label: 'Workers', value: '2450' },
            ].map((item, i) => {
              // Add margin only after row 2 (i=1) and row 4 (i=3)
              const rowGapClass = (i === 1 || i === 3) ? 'mb-3 md:mb-5' : '';
              return (
                <React.Fragment key={i}>
                  <div className={`md:text-[14px] md:w-[215px] text-[6px] text-black ${rowGapClass}`}>
                    {item.label}
                  </div>
                  {[...Array(9)].map((_, j) => (
                    <div
                      key={j}
                      className={`md:h-5 h-4 md:h-[27px] bg-[#CFD7D7] rounded-md text-[5px] md:text-[16px] flex items-center justify-center ${rowGapClass}`}
                    >
                      {item.value}
                    </div>
                  ))}
                </React.Fragment>
              );
            })}
          </div>
        </div>
             {/* LAND Section */}
             <div className="md:mt-6">
          <p className="text-[#F38323] font-semibold mb-2 text-[6px] md:text-[20px]">LAND</p>
          <div className='h-[2.5px] bg-black/50'></div>

          <div className="grid md:grid-cols-[300px_repeat(9,1fr)] grid-cols-[90px_repeat(9,1fr)] md:gap-y-4  gap-y-1  md:gap-x-2 gap-x-1 md:mt-3 mt-1">
            {[
              { label: 'No of Farms', value: '345' },
              { label: 'Size of Land (Ha)', value: '2450' },
              
            ].map((item, i) => {
              // Add margin only after row 2 (i=1) and row 4 (i=3)
              const rowGapClass = (i === 1 || i === 3) ? 'mb-3 md:mb-5' : '';
              return (
                <React.Fragment key={i}>
                  <div className={`md:text-[14px] md:w-[215px] text-[6px] text-black ${rowGapClass}`}>
                    {item.label}
                  </div>
                  {[...Array(9)].map((_, j) => (
                    <div
                      key={j}
                      className={`md:h-5 h-4 md:h-[27px] bg-[#CFD7D7] rounded-md text-[5px] md:text-[16px] flex items-center justify-center ${rowGapClass}`}
                    >
                      {item.value}
                    </div>
                  ))}
                </React.Fragment>
              );
            })}
          </div>
        </div>
          {/* LAND Section */}
          <div className="mt-2">
          <p className="text-[#F38323] font-semibold mb-2 text-[6px] md:text-[20px]">EIA</p>
          <div className='h-[2.5px] bg-black/50'></div>

          <div className="grid md:grid-cols-[300px_repeat(9,1fr)] grid-cols-[90px_repeat(9,1fr)] md:gap-y-4 gap-y-1  md:gap-x-2 gap-x-1 md:mt-3 mt-1">
            {[
              { label: 'EIA Costing', value: '345' },
              { label: 'EIA Comment', value: 'Approved' },
              
            ].map((item, i) => {
              // Add margin only after row 2 (i=1) and row 4 (i=3)
              const rowGapClass = (i === 1 || i === 3) ? 'mb-3 md:mb-5' : '';
              return (
                <React.Fragment key={i}>
                  <div className={`md:text-[14px] md:w-[215px] text-[6px] text-black ${rowGapClass}`}>
                    {item.label}
                  </div>
                  {[...Array(9)].map((_, j) => (
                    <div
                      key={j}
                      className={`md:h-5 h-4 md:h-[27px] bg-[#CFD7D7] rounded-md text-[5px] md:text-[16px] flex items-center justify-center ${rowGapClass}`}
                    >
                      {item.value}
                    </div>
                  ))}
                </React.Fragment>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeatMap;
